import React, { useEffect, useRef } from "react";
import TabulatorTable from "@/comp/TabulatorTable";

const SearchOrderHistoryTable = ({ rows, layoutVersion, open, statusLabels, onOrderClick }) => {
  const tableRef = useRef(null);
  const rowsRef = useRef(rows);
  const statusLabelsRef = useRef(statusLabels);
  const onOrderClickRef = useRef(onOrderClick);
  rowsRef.current = rows;
  statusLabelsRef.current = statusLabels;
  onOrderClickRef.current = onOrderClick;

  useEffect(() => {
    tableRef.current?.setData?.(rows);
  }, [rows]);

  useEffect(() => {
    if (!open) return;
    const frame = window.requestAnimationFrame(() => tableRef.current?.redraw?.(true));
    return () => window.cancelAnimationFrame(frame);
  }, [layoutVersion, open]);

  const handleReady = (table) => {
    tableRef.current = table;
    table.setData(rowsRef.current);
    table.on("rowClick", (_, row) => onOrderClickRef.current?.(row.getData()));
  };

  const options = {
    index: "ORDER_HIST_ID",
    height: "100%",
    layout: "fitDataStretch",
    placeholder: "조회된 주문 이력이 없습니다.",
    columns: [
      {
        title: "주문번호",
        field: "ORDER_NO",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 110,
        minWidth: 110,
        headerSort: false,
      },
      {
        title: "주문일자",
        field: "ORDER_DATE",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 110,
        minWidth: 110,
        headerSort: false,
      },
      {
        title: "주문자",
        field: "ORDERER",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 100,
        minWidth: 100,
        headerSort: false,
      },
      {
        title: "직납",
        field: "DIRECT_DELIVERY_YN",
        headerHozAlign: "center",
        hozAlign: "center",
        formatter: "checkBox",
        formatterParams: {
          trueValue: "Y",
          falseValue: "N",
        },
        width: 55,
        minWidth: 55,
        headerSort: false,
        resizable: false,
      },
      {
        title: "주문상태",
        field: "ORDER_STATUS_CD",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 110,
        minWidth: 110,
        headerSort: false,
        formatter: (cell) => statusLabelsRef.current?.[String(cell.getValue())] ?? cell.getValue() ?? "",
      },
      {
        title: "산지",
        field: "ORIGIN_NM",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 110,
        minWidth: 110,
        headerSort: false,
      },
      {
        title: "상차지",
        field: "LOAD_PLACE_NM",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 110,
        minWidth: 110,
        headerSort: false,
      },
      {
        title: "납품처",
        field: "DELIVERY_PLACE_NM",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 145,
        minWidth: 145,
        headerSort: false,
      },
      {
        title: "품목",
        field: "ITEM_NM",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 100,
        minWidth: 100,
        headerSort: false,
      },
      {
        title: "PLT",
        field: "PALLET_QTY",
        headerHozAlign: "center",
        hozAlign: "right",
        width: 70,
        minWidth: 70,
        headerSort: false,
      },
      {
        title: "BOX",
        field: "BOX_QTY",
        headerHozAlign: "center",
        hozAlign: "right",
        width: 70,
        minWidth: 70,
        headerSort: false,
      },
      {
        title: "수정자",
        field: "CHGE_ID",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 100,
        minWidth: 100,
        headerSort: false,
      },
      {
        title: "수정일시",
        field: "CHGE_DTTM",
        headerHozAlign: "center",
        hozAlign: "center",
        width: 155,
        minWidth: 155,
        headerSort: false,
      },
    ],
  };

  return <div style={{ height: "100%", minHeight: 0 }}><TabulatorTable ref={tableRef} data={rows} options={options} onReady={handleReady} fullHeight /></div>;
};

export default SearchOrderHistoryTable;
